/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ShiftArea } from './ShiftArea';
import {
    ShiftAreaFromJSON,
    ShiftAreaFromJSONTyped,
    ShiftAreaToJSON,
    ShiftAreaToJSONTyped,
} from './ShiftArea';

/**
 * 
 * @export
 * @interface ListShiftAreasResponse
 */
export interface ListShiftAreasResponse {
    /**
     * 
     * @type {Array<ShiftArea>}
     * @memberof ListShiftAreasResponse
     */
    data: Array<ShiftArea>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListShiftAreasResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListShiftAreasResponse interface.
 */
export function instanceOfListShiftAreasResponse(value: object): value is ListShiftAreasResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListShiftAreasResponseFromJSON(json: any): ListShiftAreasResponse {
    return ListShiftAreasResponseFromJSONTyped(json, false);
}

export function ListShiftAreasResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListShiftAreasResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ShiftAreaFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListShiftAreasResponseToJSON(json: any): ListShiftAreasResponse {
      return ListShiftAreasResponseToJSONTyped(json, false);
  }

  export function ListShiftAreasResponseToJSONTyped(value?: ListShiftAreasResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ShiftAreaToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

